import LocalModal from 'components/base/local-modal';
import React from 'react';
import { ReactComponent as LogOutIcon } from 'assets/icons/logout-icon.svg';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';

import { toast } from 'react-toastify';
import useDashboardContext from 'contexts/dashboard.context';
import useAxios from 'hooks/useAxios';
import { handleApiError } from 'utils/functions';

type Props = {
  refetchAllBranchesAddress?: () => void;
  isOpen: boolean;
  onClose: () => void;
  id: string;
};
const DeleteBranchAddress = ({ isOpen, onClose, id, refetchAllBranchesAddress }: Props) => {
  const { activeCompany } = useDashboardContext();

  const { fetchData: deleteOrgBranchAddress, loading: isDeletingBrand } = useAxios({
    url: `branches/${activeCompany?.id}/${id}`,
    method: 'delete'
  });

  const handleDeleteBrandAddress = async () => {
    try {
      await deleteOrgBranchAddress();
      refetchAllBranchesAddress?.();
      toast(<ToastMessage message='Branch address deleted successfully' type='success' />);
      onClose();
    } catch (err) {
      handleApiError(err);
    }
  };

  return (
    <LocalModal isOpen={isOpen} onRequestClose={onClose} title=''>
      <div className='w-[70%] mx-auto flex flex-col justify-center items-center'>
        <LogOutIcon className='mb-4' />
        <p className='text-gray-10'>Delete Address</p>
        <p className='text-[#6F7376] text-sm'>This will remove this address from your list</p>
        <div className='w-full flex justify-between'>
          <Button
            variant='block'
            color='gray'
            className='mt-8 h-[41px] w-[139px] !bg-[#F2F2F2] !border-[#F2F2F2] !text-[#2E3031]'
            onClick={() => onClose()}>
            Cancel
          </Button>
          <Button
            variant='block'
            color='primary'
            className='mt-8 h-[41px] w-[139px]'
            loading={isDeletingBrand}
            onClick={handleDeleteBrandAddress}>
            Confirm
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default DeleteBranchAddress;
